module.exports = __webpack_public_path__ + "static/media/icon_close.2b99781e.svg";